import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  clearBankAccount,
  getBankAccount,
  putBankAccount,
} from '../../../../actions';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import BankAccountForm from './BankAccountForm';
import { BANK_ACCOUNT_PATH } from '../../../../config/paths';
import { CURRENCY_TYPE } from '../../../../config/constants';

const EditBankAccount = ({
  breadcrumbs,
  dispatchGetBankAccount,
  dispatchClearBankAccount,
  dispatchPutBankAccount,
  match: {
    params: { id: bankAccountId },
  },
  loading,
  bankAccount,
}) => {
  useLayoutEffect(() => {
    dispatchGetBankAccount({ bankAccountId });

    return () => dispatchClearBankAccount();
  }, []);

  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      bankId: formValues.bankId ? formValues.bankId.value : null,
      businessId: formValues.businessId ? formValues.businessId.value : null,
      currency: formValues.currency ? formValues.currency.value : null,
      active: formValues.active,
    };

    dispatchPutBankAccount(bankAccountId, newFormValues);
  };

  const generateInitialValues = ({
    accountNumber,
    interbankNumber,
    currency,
    bank,
    business,
    receipt,
    active,
    sunatTableCode,
    sysCode,
    orderNumber,
    externalAccountId,
  }) => ({
    accountNumber,
    interbankNumber,
    currency: currency ? CURRENCY_TYPE[currency] : null,
    bankId: {
      value: bank.id,
      label: bank.name,
    },
    businessId: {
      value: business.id,
      label: business.name,
    },
    receipt,
    active,
    sunatTableCode,
    sysCode,
    orderNumber,
    externalAccountId,
  });

  let content;

  if (loading) content = <Loader />;
  else if (bankAccount.isEmpty())
    content = <NoDataResource returnPage={BANK_ACCOUNT_PATH} />;
  else
    content = (
      <BankAccountForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(bankAccount.toJS())}
        active
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Cuenta Bancaria"
      subtitle="Editar cuenta bancaria"
      content={content}
    />
  );
};

EditBankAccount.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearBankAccount: PropTypes.func.isRequired,
  dispatchGetBankAccount: PropTypes.func.isRequired,
  dispatchPutBankAccount: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  bankAccount: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditBankAccount.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearBankAccount: clearBankAccount,
  dispatchGetBankAccount: getBankAccount,
  dispatchPutBankAccount: putBankAccount,
};

const mapStateToProps = (
  { AccountingUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cuentas Bancarias',
      href: BANK_ACCOUNT_PATH,
    },
    {
      text: 'Ver',
      href: `${BANK_ACCOUNT_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  bankAccount: AccountingUnit.BankAccount.getIn(['current', 'content']),
  loading: !AccountingUnit.BankAccount.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditBankAccount);
